// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"faq_wrapper__r8LgE"};